export default __webpack_public_path__ + "static/media/thumbnail.0ff70f57.png";